import React from "react";
import { createPortal } from "react-dom";
import ReactTooltip, { Place, Effect } from "react-tooltip";

import "./Tooltip.scss"

interface TooltipProps {
    place?: TooltipSide,
    effect?: Effect
}

interface TooltipState {
    place: Place,
    usePlace: TooltipSide,
    useEffect: Effect
}

type TooltipSide = "top" | "right" | "bottom" | "left" | "auto";

class Tooltip extends React.Component<TooltipProps, TooltipState> {

    state = {
        place: (this.props.place ?? "right") as Place,
        usePlace: this.props.place ?? "auto",
        useEffect: this.props.effect ?? "solid"
    };

    overridePosition(pos, event, element: HTMLElement, tooltip) {
        let winWidth = window.innerWidth,
            winHeight = window.innerHeight,
            elmHeight = element.offsetHeight,
            elmWidth = element.offsetWidth,
            elmOffset = element.getBoundingClientRect(),
            tipHeight = tooltip.offsetHeight,
            tipWidth = tooltip.offsetWidth,
            usePlace = element.attributes["data-place"]?.value ?? this.state.usePlace ?? "auto",
            posix = {
                left: elmOffset.left,
                right: winWidth - (elmOffset.left + elmWidth),
                top: elmOffset.top,
                bottom: winHeight - (elmHeight + elmOffset.top)
            },
            bestPosition = usePlace === "auto" ? Object.keys(posix).reduce(function (best, key) {
                return posix[best] > posix[key] ? best : key;
            }) : usePlace;

        let useTop = 0,
            useLeft = 0;
        switch (bestPosition) {
            case "left":
                useTop = elmOffset.top + elmHeight / 2 - tipHeight / 2;
                useLeft = elmOffset.left - tipWidth + 5;
                break;
            case "right":
                useTop = elmOffset.top + elmHeight / 2 - tipHeight / 2;
                useLeft = elmOffset.left + elmWidth - 5;
                break;
            case "top":
                useTop = elmOffset.top - tipHeight + 5;
                useLeft = elmOffset.left + elmWidth / 2 - tipWidth / 2;
                break;
            case "bottom":
                useTop = elmOffset.top + elmHeight - 5;
                useLeft = elmOffset.left + elmWidth / 2 - tipWidth / 2;
                break;
        }

        return {
            top: Math.min(Math.max(0, useTop), winHeight - tipHeight),
            left: Math.min(Math.max(0, useLeft), winWidth - elmWidth)
        };
    }

    render(): React.ReactNode {

        return (
        createPortal(
        <ReactTooltip place={this.state.place}
                      effect={this.state.useEffect}
                      delayShow={500}
                      delayHide={0}
                      overridePosition={(pos, event, element, tooltip) => this.overridePosition(pos, event, element as HTMLElement, tooltip)}>
        </ReactTooltip>,
        document.getElementsByClassName("page-elements")[0])
        );
        
    }
}

export default Tooltip;